import { render, staticRenderFns } from "./ontick-table.component.vue?vue&type=template&id=ea179fee&scoped=true"
import script from "./ontick-table.component.vue?vue&type=script&lang=js"
export * from "./ontick-table.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-table.component.vue?vue&type=style&index=0&id=ea179fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea179fee",
  null
  
)

export default component.exports